import { FocusTimeBadge } from "./focus-time-badge";
import { MeetingReliefBadge } from "./meeting-relief-badge";

export const SmartHoldBadges = {
  FocusTime: FocusTimeBadge,
  MeetingRelief: MeetingReliefBadge,
};
